module.exports = __webpack_public_path__ + "img/rebound_silver.1ff24942.svg";